cc.Class({
    extends: cc.Component,

    properties: {
        maxWidth: 2000,
        leftMargin: 0,
        rightMargin: 0,
        leftMarginPortrait: 0,
        rightMarginPortrait: 0,
    },

    onLoad () {
        this.isLandscape = true;
        this.resizeManager = cc.find('ResizeManager').getComponent('ResizeManager');
        this.resizeManager.appendNode(this);
    },

    onDestroy () {
        this.resizeManager.removeNode(this);
    },

    onViewResize(_screenRatio, aspectRatio) {
        this.isLandscape = aspectRatio > 1;
        const lM = this.isLandscape ? this.leftMargin : this.leftMarginPortrait;
        const rM = this.isLandscape ? this.rightMargin : this.rightMarginPortrait;
        let { width } = cc.view.getVisibleSize();
        width -= lM;
        width -= rM;

        this.node.width = Math.min(this.maxWidth, width);
    }
});
